<style lang="scss" scoped>
.slideout-container {
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	display: flex;
	z-index: 1030;
	pointer-events: none;
	transition: background 0.3s;
	.slideout {
		background: #fff;
		padding: 45px;
		width: 75%;
		margin-right: -75%;
		margin-left: auto;
		cursor: default;
		transition: margin-right 0.3s;
		overflow: auto;
	}
	&.open {
		background: rgba(#8296a0, 0.4);
		pointer-events: all;
		cursor: pointer;
		.slideout {
			margin-right: 0;
			box-shadow: -15px 0 15px rgba(72, 98, 111, 0.15);
		}
	}
}
</style>

<template>
    <div class="slideout-container" :class="{ open : open}" @click="$emit('close')">
        <div class="slideout" @click.stop>
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
export default {
	props: {
		/**
		 * Boolean defining the open status of the slideout
		 * @type {Boolean}
		 */
		open: {
			type: Boolean,
			default: true
		}
	},
	watch: {
		open: function() {
			if (this.open) document.querySelector('body').style.overflow = 'hidden'
			else document.querySelector('body').style.overflow = 'auto'
		}
	}
}
</script>
